import React from 'react';
import ListComponent from '..';
import ListItemAssignLab from '../Item/ListItemAssignLab';

const ListAssignLaboratories = ({list}) => {
    return (
        <ListComponent mini={false} empty={'fabricantes'} titles={['País','Compañía','Fabricante']} list={list} ListComponent={ListItemAssignLab}  />
    );
};

export default ListAssignLaboratories;